/** Aligns with admin off-market MIN_SPECIAL_COMMISSION_PCT (default baseline). */
export const OFF_MARKET_DEFAULT_COMMISSION_PCT = 6;

export function roundOffMarketCommissionPct(n) {
  return Math.round(Number(n) * 10) / 10;
}

/**
 * @param {object|null|undefined} sc – specialCommission from API
 * @returns {{ total: number, defaultBase: number, specialAdded: number } | null}
 */
export function getOffMarketSpecialCommissionBreakdown(sc) {
  if (!sc || sc.percentage == null || sc.percentage === '') return null;
  const total = roundOffMarketCommissionPct(sc.percentage);
  if (Number.isNaN(total)) return null;
  let specialAdded;
  if (
    sc.specialAddedPercentage != null &&
    sc.specialAddedPercentage !== '' &&
    !Number.isNaN(Number(sc.specialAddedPercentage))
  ) {
    specialAdded = roundOffMarketCommissionPct(sc.specialAddedPercentage);
  } else {
    specialAdded = roundOffMarketCommissionPct(
      Math.max(0, total - OFF_MARKET_DEFAULT_COMMISSION_PCT),
    );
  }
  return {
    total,
    defaultBase: OFF_MARKET_DEFAULT_COMMISSION_PCT,
    specialAdded,
  };
}
